import React from 'react';
import {List, Datagrid, TextField, TopToolbar, CreateButton, sanitizeListRestProps} from 'react-admin';


const ListActions = ({...rest}) => (
  <TopToolbar {...sanitizeListRestProps(rest)}>
      <CreateButton label="Add" />
  </TopToolbar>
);

export const FirmwareList = props => {
  console.log(props);
  return (
    <>
      <List title='Hydrant Fleet Management - Firmwares' exporter={false} actions={<ListActions />} perPage={50}>
        <Datagrid isRowSelectable={()=>(false)}>
          <TextField label="Id" source="id" />
          <TextField label="Version" source="version" />
          <TextField label="Description" source="description" />
        </Datagrid>
      </List>
    </>  
  );
};
  